/* ==========================================================================
   Óptica Córdoba — Página de producto (arquitectura Oliver Peoples)
   Comportamiento: galería, raíl de progreso, modales, descripción,
   Inside Story, slider de detalles y carruseles. Sin dependencias.
   ========================================================================== */
(function () {
  'use strict';

  /* El script podría incluirse más de una vez (layout + sección); una sola
     ejecución basta y evita duplicar listeners. */
  if (window.__opPdpLoaded) return;
  window.__opPdpLoaded = true;

  var DESKTOP = '(min-width: 1024px)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ------------------------------------------------------------------------
     1. MODALES
     --------------------------------------------------------------------- */
  var lastFocused = null;

  function openModal(modal) {
    if (!modal) return;
    lastFocused = document.activeElement;
    modal.setAttribute('data-open', '');
    modal.removeAttribute('aria-hidden');
    document.body.classList.add('op-modal-open');
    var close = $('.op-modal__close', modal);
    if (close) close.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.removeAttribute('data-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('op-modal-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function initModals() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-op-modal-open]');
      if (opener) {
        var modal = document.getElementById(opener.getAttribute('data-op-modal-open'));
        if (modal) {
          event.preventDefault();
          openModal(modal);
          var index = opener.getAttribute('data-op-modal-index');
          if (typeof modal.__opLightboxShow === 'function') {
            modal.__opLightboxShow(Number(index) || 0);
          } else if (index) {
            var target = $$('.op-modal__media > *', modal)[Number(index)];
            if (target) {
              var scroller = $('.op-modal__scroll', modal);
              if (scroller) scroller.scrollTop = target.offsetTop;
            }
          }
        }
        return;
      }
      var closer = event.target.closest('[data-op-modal-close]');
      if (closer) {
        event.preventDefault();
        closeModal(closer.closest('.op-modal'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = $('.op-modal[data-open]');
      if (open) closeModal(open);
    });
  }

  /* ------------------------------------------------------------------------
     1b. LIGHTBOX (visor de galería estilo Oliver Peoples)
     En escritorio muestra una imagen a la vez con flechas, miniaturas y
     zoom. En móvil/tablet mantiene el desplazamiento vertical original.
     --------------------------------------------------------------------- */
  function initLightbox(box) {
    var media = $('[data-op-lightbox-media]', box);
    if (!media) return;
    var slides = $$('[data-op-lightbox-slide]', media);
    if (!slides.length) return;

    var thumbs = $$('[data-op-lightbox-thumb]', box);
    var prevBtn = $('[data-op-lightbox-prev]', box);
    var nextBtn = $('[data-op-lightbox-next]', box);
    var zoomInBtn = $('[data-op-zoom-in]', box);
    var zoomOutBtn = $('[data-op-zoom-out]', box);
    var scroll = $('.op-modal__scroll', box);

    var ZOOM_MIN = 1;
    var ZOOM_MAX = 3;
    var ZOOM_STEP = 0.6;
    var index = 0;
    var zoom = 1;
    var panX = 0;
    var panY = 0;

    function desktop() {
      return window.matchMedia(DESKTOP).matches;
    }
    function activeImg() {
      var slide = slides[index];
      return slide ? slide.querySelector('img') : null;
    }

    function clampPan() {
      var img = activeImg();
      var slide = slides[index];
      if (!img || !slide) {
        panX = 0;
        panY = 0;
        return;
      }
      var maxX = Math.max(0, (img.offsetWidth * zoom - slide.clientWidth) / 2);
      var maxY = Math.max(0, (img.offsetHeight * zoom - slide.clientHeight) / 2);
      panX = Math.min(maxX, Math.max(-maxX, panX));
      panY = Math.min(maxY, Math.max(-maxY, panY));
    }

    function applyTransform() {
      var img = activeImg();
      if (!img) return;
      img.style.transform =
        'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')';
    }

    function updateZoomButtons() {
      if (zoomOutBtn) zoomOutBtn.disabled = zoom <= ZOOM_MIN;
      if (zoomInBtn) zoomInBtn.disabled = zoom >= ZOOM_MAX;
    }

    function setZoom(next) {
      zoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(next * 100) / 100));
      if (zoom <= ZOOM_MIN) {
        panX = 0;
        panY = 0;
      }
      clampPan();
      applyTransform();
      box.toggleAttribute('data-zoomed', zoom > ZOOM_MIN);
      updateZoomButtons();
    }

    function resetZoom() {
      zoom = ZOOM_MIN;
      panX = 0;
      panY = 0;
      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        if (img) img.style.transform = '';
      });
      box.removeAttribute('data-zoomed');
      updateZoomButtons();
    }

    function keepThumbInView(thumb) {
      var lane = thumb.parentNode;
      if (!lane || lane.scrollWidth <= lane.clientWidth) return;
      var tr = thumb.getBoundingClientRect();
      var lr = lane.getBoundingClientRect();
      var pad = 16;
      var delta = 0;
      if (tr.left < lr.left + pad) delta = tr.left - lr.left - pad;
      else if (tr.right > lr.right - pad) delta = tr.right - lr.right + pad;
      if (delta) lane.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    /* Fuerza la descarga de una diapositiva: las imágenes del modal son lazy y
       no se cargan mientras está oculto, así que al abrir o navegar aparecerían
       en blanco. Cargamos la activa y sus vecinas para que el cambio sea inmediato. */
    function loadSlide(i) {
      var slide = slides[(i + slides.length) % slides.length];
      var img = slide && slide.querySelector('img');
      if (!img || img.dataset.opLoaded === '1') return;
      img.dataset.opLoaded = '1';
      if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
      if (!img.complete && img.getAttribute('src')) img.src = img.getAttribute('src');
    }

    function show(i, opts) {
      opts = opts || {};
      index = (i + slides.length) % slides.length;
      resetZoom();
      loadSlide(index);
      loadSlide(index + 1);
      loadSlide(index - 1);
      slides.forEach(function (slide, k) {
        slide.toggleAttribute('data-active', k === index);
      });
      thumbs.forEach(function (thumb, k) {
        var on = k === index;
        thumb.setAttribute('aria-current', String(on));
        if (on && desktop()) keepThumbInView(thumb);
      });
      /* En móvil el modal es un scroll vertical: llevar la imagen a la vista. */
      if (!desktop() && !opts.noScroll && scroll) {
        scroll.scrollTop = slides[index].offsetTop;
      }
    }

    /* Expuesto para que la apertura del modal seleccione la imagen pedida. */
    box.__opLightboxShow = show;

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        show(index - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        show(index + 1);
      });
    }
    thumbs.forEach(function (thumb, k) {
      thumb.addEventListener('click', function () {
        show(k);
      });
    });
    if (zoomInBtn) {
      zoomInBtn.addEventListener('click', function () {
        setZoom(zoom + ZOOM_STEP);
      });
    }
    if (zoomOutBtn) {
      zoomOutBtn.addEventListener('click', function () {
        setZoom(zoom - ZOOM_STEP);
      });
    }

    /* Flechas del teclado mientras el visor está abierto (escritorio). */
    box.addEventListener('keydown', function (event) {
      if (!box.hasAttribute('data-open') || !desktop()) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });

    /* Arrastrar para desplazar la imagen cuando hay zoom (escritorio). */
    var dragging = false;
    var startX = 0;
    var startY = 0;
    var originX = 0;
    var originY = 0;
    media.addEventListener('pointerdown', function (event) {
      if (!desktop() || zoom <= ZOOM_MIN) return;
      if (event.target.closest('[data-op-lightbox-thumb]')) return;
      dragging = true;
      startX = event.clientX;
      startY = event.clientY;
      originX = panX;
      originY = panY;
      media.setAttribute('data-panning', '');
      if (media.setPointerCapture) media.setPointerCapture(event.pointerId);
    });
    media.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      panX = originX + (event.clientX - startX);
      panY = originY + (event.clientY - startY);
      clampPan();
      applyTransform();
    });
    var endDrag = function () {
      if (!dragging) return;
      dragging = false;
      media.removeAttribute('data-panning');
    };
    media.addEventListener('pointerup', endDrag);
    media.addEventListener('pointercancel', endDrag);
    media.addEventListener('pointerleave', endDrag);

    show(0, { noScroll: true });
  }

  /* ------------------------------------------------------------------------
     2. GALERÍA
     --------------------------------------------------------------------- */
  function initGallery(root) {
    var slider = $('[data-op-slider]', root);
    var counter = $('[data-op-counter]', root);
    var drag = $('[data-op-scrollbar-drag]', root);

    if (slider) {
      var slides = $$('.op-gallery__slide', slider).length || 1;
      var syncSlider = function () {
        var max = slider.scrollWidth - slider.clientWidth;
        var ratio = max > 0 ? slider.scrollLeft / max : 0;
        if (drag) {
          drag.style.width = 100 / slides + '%';
          drag.style.transform = 'translateX(' + ratio * (slides - 1) * 100 + '%)';
        }
        if (counter) {
          var index = Math.round(slider.scrollLeft / Math.max(slider.clientWidth, 1)) + 1;
          counter.textContent = Math.min(index, slides);
        }
      };
      slider.addEventListener('scroll', syncSlider, { passive: true });
      window.addEventListener('resize', syncSlider);
      syncSlider();
    }

    /* Raíl de progreso vertical (desktop) */
    var progress = $('[data-op-progress]', root);
    if (progress) {
      var onScroll = function () {
        if (!window.matchMedia(DESKTOP).matches) return;
        var rect = root.getBoundingClientRect();
        var travel = rect.height - window.innerHeight;
        var value = travel > 0 ? -rect.top / travel : 0;
        progress.style.setProperty('--op-progress', Math.min(1, Math.max(0, value)).toFixed(4));
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }
  }

  /* ------------------------------------------------------------------------
     3. DESCRIPCIÓN DESPLEGABLE
     --------------------------------------------------------------------- */
  function initDescription(root) {
    $$('[data-op-desc-toggle]', root).forEach(function (button) {
      var body = $('#' + button.getAttribute('aria-controls'));
      if (!body) return;
      var clip = $('.op-desc__clip', body);
      button.addEventListener('click', function () {
        var open = body.hasAttribute('data-open');
        if (open) {
          body.removeAttribute('data-open');
          if (clip) clip.style.minHeight = '';
          button.setAttribute('aria-expanded', 'false');
        } else {
          body.setAttribute('data-open', '');
          if (clip) clip.style.minHeight = '0';
          button.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     4. FORMULARIO DE COMPRA (añadir al carrito sin recargar)
     --------------------------------------------------------------------- */
  function initBuyForm(root) {
    var form = $('[data-op-buy-form]', root);
    if (!form) return;
    var error = $('[data-op-buy-error]', root);
    var submit = $('[data-op-buy-submit]', form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!submit || submit.disabled) return;
      var original = submit.getAttribute('data-label') || submit.textContent.trim();
      submit.setAttribute('data-label', original);
      submit.disabled = true;
      if (error) error.removeAttribute('data-visible');

      var body = new FormData(form);
      var sections = [];
      var drawer = document.querySelector('cart-drawer, cart-notification');
      if (drawer && drawer.getSectionsToRender) {
        drawer.getSectionsToRender().forEach(function (section) {
          sections.push(section.id);
        });
        body.append('sections', sections.join(','));
        body.append('sections_url', window.location.pathname);
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: body,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) {
            if (error) {
              error.textContent = data.description || data.message;
              error.setAttribute('data-visible', '');
            }
            return;
          }
          if (drawer && drawer.renderContents) {
            drawer.renderContents(data);
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
          document.dispatchEvent(new CustomEvent('op:cart:added'));
        })
        .catch(function () {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .finally(function () {
          submit.disabled = false;
        });
    });
  }

  /* ------------------------------------------------------------------------
     5. INSIDE STORY
     --------------------------------------------------------------------- */
  function initStory(root) {
    var tabButtons = $$('[data-op-story-tab]', root);
    var panels = $$('[data-op-story-panel]', root);
    var cards = $$('[data-op-story-card]', root);
    var figures = $$('[data-op-story-figure]', root);
    var strip = $('[data-op-story-strip]', root);

    function activateTab(tab) {
      tabButtons.forEach(function (button) {
        button.setAttribute('aria-selected', String(button.getAttribute('data-op-story-tab') === tab));
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-op-story-panel') !== tab;
      });
      cards.forEach(function (card) {
        card.hidden = card.getAttribute('data-op-story-card') !== tab;
      });
      var firstVisible = panels.filter(function (panel) {
        return !panel.hidden;
      })[0];
      setActiveFigure(firstVisible ? firstVisible.getAttribute('data-op-story-key') : null);
      if (strip) strip.scrollLeft = 0;
    }

    function setActiveFigure(key) {
      var matched = false;
      figures.forEach(function (figure) {
        var on = key !== null && figure.getAttribute('data-op-story-figure') === key;
        if (on) matched = true;
        figure.toggleAttribute('data-active', on);
      });
      if (!matched && figures[0]) figures[0].setAttribute('data-active', '');
    }

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        activateTab(button.getAttribute('data-op-story-tab'));
      });
    });

    if (panels.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActiveFigure(entry.target.getAttribute('data-op-story-key'));
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );
      panels.forEach(function (panel) {
        observer.observe(panel);
      });
    }

    if (strip) {
      strip.addEventListener('scroll', function () {
        var index = Math.round(strip.scrollLeft / Math.max(strip.clientWidth, 1));
        var visible = cards.filter(function (card) {
          return !card.hidden;
        });
        var card = visible[index];
        if (card) setActiveFigure(card.getAttribute('data-op-story-key'));
      }, { passive: true });
    }

    if (tabButtons.length) activateTab(tabButtons[0].getAttribute('data-op-story-tab'));
    else setActiveFigure(panels[0] ? panels[0].getAttribute('data-op-story-key') : null);
  }

  /* ------------------------------------------------------------------------
     6. SLIDER HORIZONTAL (detalles y productos relacionados)
     --------------------------------------------------------------------- */
  function initTrack(track) {
    if (!track) return;
    var bullets = [];
    var paginationId = track.getAttribute('data-op-pagination');
    var pagination = paginationId ? document.getElementById(paginationId) : null;
    if (pagination) bullets = $$('[data-op-bullet]', pagination);
    var nextBtn = pagination ? pagination.querySelector('[data-op-next]') : null;

    var slides = $$(':scope > *', track);

    function goTo(i) {
      var slide = slides[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function currentIndex() {
      var width = slides[0] ? slides[0].offsetWidth : track.clientWidth;
      return Math.round(track.scrollLeft / Math.max(width, 1));
    }

    /* Mantiene visible la pestaña activa dentro de su carril, sin mover la página */
    function keepInView(tab) {
      var lane = tab.parentNode;
      if (!lane || lane.scrollWidth <= lane.clientWidth) return;
      var tr = tab.getBoundingClientRect();
      var lr = lane.getBoundingClientRect();
      var pad = 16;
      var delta = 0;
      if (tr.left < lr.left + pad) {
        delta = tr.left - lr.left - pad;
      } else if (tr.right > lr.right - pad) {
        delta = tr.right - lr.right + pad;
      }
      if (delta) lane.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function sync() {
      var index = currentIndex();
      bullets.forEach(function (bullet, i) {
        var active = i === index;
        bullet.setAttribute('aria-current', String(active));
        if (active) keepInView(bullet);
      });
    }

    track.addEventListener('scroll', sync, { passive: true });

    /* Evita el arrastre fantasma nativo de imágenes/enlaces: así arrastrar con el
       puntero mueve el carrusel en lugar de "coger" la foto (que dejaba la
       diapositiva a medias y cortaba el texto). */
    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    bullets.forEach(function (bullet, i) {
      bullet.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var next = currentIndex() + 1;
        if (next >= slides.length) next = 0;
        goTo(next);
      });
    }

    /* Arrastre con puntero en desktop */
    var down = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      down = true;
      moved = false;
      startX = event.clientX;
      startScroll = track.scrollLeft;
    });
    track.addEventListener('pointermove', function (event) {
      if (!down) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 4) {
        moved = true;
        track.setAttribute('data-dragging', '');
        track.scrollLeft = startScroll - delta;
      }
    });
    var release = function () {
      if (!down) return;
      down = false;
      track.removeAttribute('data-dragging');
      if (moved) goTo(currentIndex());
    };
    track.addEventListener('pointerup', release);
    track.addEventListener('pointerleave', release);
    track.addEventListener('click', function (event) {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }, true);

    sync();
  }

  /* ------------------------------------------------------------------------
     6b. DETALLES — panel con pestañas + fundido (sin scroll horizontal)
     --------------------------------------------------------------------- */
  function initFeatures(root) {
    var slides = $$('[data-op-panel]', root);
    if (!slides.length) return;
    var tabs = $$('[data-op-tab]', root);
    var prev = root.querySelector('[data-op-prev]');
    var next = root.querySelector('[data-op-next]');
    var track = root.querySelector('[data-op-panels]');
    var index = 0;

    /* Mantiene visible la pestaña activa dentro de su carril, sin mover la página */
    function keepInView(tab) {
      var lane = tab.parentNode;
      if (!lane || lane.scrollWidth <= lane.clientWidth) return;
      var tr = tab.getBoundingClientRect();
      var lr = lane.getBoundingClientRect();
      var pad = 16;
      var delta = 0;
      if (tr.left < lr.left + pad) {
        delta = tr.left - lr.left - pad;
      } else if (tr.right > lr.right - pad) {
        delta = tr.right - lr.right + pad;
      }
      if (delta) lane.scrollBy({ left: delta, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        if (k === index) s.setAttribute('data-active', '');
        else s.removeAttribute('data-active');
      });
      tabs.forEach(function (t, k) {
        var active = k === index;
        t.setAttribute('aria-current', String(active));
        if (active) keepInView(t);
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        show(i);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        show(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        show(index + 1);
      });
    }

    /* Arrastrar/deslizar la pieza para pasar a la siguiente (o anterior) */
    if (track) {
      var downX = null;
      var downY = null;
      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
      track.addEventListener('pointerdown', function (event) {
        downX = event.clientX;
        downY = event.clientY;
        track.setAttribute('data-dragging', '');
      });
      var end = function (event) {
        if (downX === null) return;
        var dx = event.clientX - downX;
        var dy = event.clientY - downY;
        downX = null;
        downY = null;
        track.removeAttribute('data-dragging');
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          show(dx < 0 ? index + 1 : index - 1);
        }
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', function () {
        downX = null;
        downY = null;
        track.removeAttribute('data-dragging');
      });
    }

    show(0);
  }

  /* ------------------------------------------------------------------------
     7. LEER MÁS
     --------------------------------------------------------------------- */
  function initReadMore(wrapper) {
    var button = $('[data-op-readmore-btn]', wrapper);
    if (!button) return;
    button.addEventListener('click', function () {
      var open = wrapper.toggleAttribute('data-open');
      button.setAttribute('aria-expanded', String(open));
    });
  }

  /* ------------------------------------------------------------------------
     8. ARRANQUE
     --------------------------------------------------------------------- */
  /* Cada nodo se inicializa una sola vez, aunque `boot` vuelva a pasar por él
     (por ejemplo cuando el editor de temas recarga una sección). */
  function once(nodes, fn) {
    nodes.forEach(function (node) {
      if (node.dataset.opReady === '1') return;
      node.dataset.opReady = '1';
      fn(node);
    });
  }

  function boot(scope) {
    var root = scope || document;
    once($$('[data-op-lightbox]', root), initLightbox);
    once($$('[data-op-gallery]', root), initGallery);
    once($$('[data-op-product]', root), function (node) {
      initDescription(node);
      initBuyForm(node);
    });
    once($$('[data-op-story]', root), initStory);
    once($$('[data-op-track]', root), initTrack);
    once($$('[data-op-features]', root), initFeatures);
    once($$('[data-op-readmore]', root), initReadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initModals();
      boot();
    });
  } else {
    initModals();
    boot();
  }

  /* Re-inicializar cuando el editor de temas recarga una sección */
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
